import { makeStyles, createStyles } from '@material-ui/core'
import { darken } from '@material-ui/core/styles'

export const useProjectChatListStyles = makeStyles((theme) =>
  createStyles({
    root: {
      textDecoration: 'none',

      '&:hover': {
        backgroundColor: darken('#fff', 0.1)
      },

      '&:not(:last-child)': {
        borderBottomWidth: 1,
        borderBottomColor: theme.palette.divider,
        borderBottomStyle: 'solid'
      }
    },

    content: {
      display: 'grid',
      gridTemplateColumns: 'auto 1fr auto',
      gridTemplateAreas: '"avatar name date" "avatar message message"',
      columnGap: theme.spacing(2),

      [theme.breakpoints.down('sm')]: {
        gridTemplateAreas:
          '"avatar name ." "avatar date ." "message message message"'
      }
    },

    avatar: {
      width: theme.spacing(8),
      height: theme.spacing(8),
      borderRadius: '100%',

      gridArea: 'avatar'
    },

    authorName: {
      fontWeight: 500,
      alignSelf: 'center',
      gridArea: 'name',

      [theme.breakpoints.down('sm')]: {
        alignSelf: 'end'
      }
    },

    date: {
      gridArea: 'date',
      alignSelf: 'center',

      [theme.breakpoints.down('sm')]: {
        alignSelf: 'flex-start'
      }
    },

    message: {
      gridArea: 'message',

      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',

      [theme.breakpoints.down('sm')]: {
        display: '-webkit-box',
        lineClamp: 4,
        boxOrient: 'vertical',
        whiteSpace: 'normal',
        marginTop: theme.spacing(3)
      }
    }
  })
)
